import {useEffect} from "react";
import {batch, useSignal} from "@preact/signals-react";
import {postSubmit} from "@ui-seeker/utils";

import { WEBBACK_V2_API } from "@constants";
import {commonFiltersValue, isLoadingCommonFilters, isSystemBusy} from "@signals";
import {elementsInLoading, sellerDeepDiveSubmittedFilters, isEmpty} from "../@signals";


export default function useSellerDeepDiveTableDetails() {

    const data = useSignal([])
    const isLoading = useSignal(false)

    useEffect(() => {
        if (isLoadingCommonFilters.value) {
            data.value = []
            isLoading.value = true
            sellerDeepDiveSubmittedFilters.value = commonFiltersValue.peek()
            postSubmit(`${WEBBACK_V2_API}/marketplaces/seller-deep-dive/context`, { ...commonFiltersValue.peek() })
                .then(res => {
                    if (!res?.data?.length)
                        isEmpty.value = true
                    data.value = res
                    isLoading.value = false
                })
                .catch(() => {
                    isLoading.value = false
                    isSystemBusy.value = true
                }).finally(() => {
                    isLoadingCommonFilters.value = false
                })
        }
    }, [isLoadingCommonFilters.value])

    useEffect(() => {
        if (isLoading.value)
            elementsInLoading.value = [...elementsInLoading.value, 'detailsTable']
        else
            elementsInLoading.value = elementsInLoading.value.filter(item => item !== 'detailsTable')
    }, [isLoading.value])

    return {
        tableData: data.value,
        isLoading: isLoading.value
    }
}